module.exports = __webpack_public_path__ + "img/Service.c81eea1a.svg";